import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Select, Row, Col, DatePicker, Button } from 'antd';
import { getTransactions } from '../actions/actions';
import 'antd/dist/antd.css';

class Search extends Component {

    constructor(props) {
        super(props);

        this.state = {
            startValue: null,
            endValue: null,
            endOpen: false,
            searchType: 'Search by Customer Email',
            searchParameter: '',
            transactionStatus: '',
            searchFlag: 'email',
            pageNo: 1,
            pageSize: 20
        }

        this.onSearchParmeterChange = this.onSearchParmeterChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    onSearchParmeterChange(e) {
        this.setState({
            searchParameter: e.target.value
        })
    }

    disabledStartDate = startValue => {
        const endValue = this.state.endValue;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = endValue => {
        const startValue = this.state.startValue;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    };

    onStartChange = value => {
        this.onChange('startValue', value);
    };

    onEndChange = value => {
        this.onChange('endValue', value);
    };

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = open => {
        this.setState({ endOpen: open });
    };


    handleChange(value) {
        this.setState({
            searchType: `Search By ${value}`,
            searchFlag: (value === 'Customer Email') ? 'email' : (value === 'Transaction Reference') ? 'reference' : ''
        });
    }

    handleStatusChange(value) {
        this.setState({
            transactionStatus: value
        });
    }

    onSearch() {
        const { startValue, endValue, searchParameter, transactionStatus, searchFlag } = this.state

        const params = {
            transactionReference: searchFlag === 'reference' ? searchParameter.trim() : '',
            startDate: startValue ? startValue._d : '',
            endDate: endValue ? endValue._d : '',
            customerEmail: searchFlag === 'email' ? searchParameter.trim() : '',
            status: transactionStatus || '',
            pageNo: 1,
        }
        this.props.getTransactions(params);
    }

    clearSearch() {
        this.setState({
            startValue: null,
            endValue: null,
            endOpen: false,
            searchParameter: '',
            transactionStatus: '',
            searchFlag: ''
        })
    }


    render() {

        const { Option } = Select;
        const { startValue, endValue, endOpen, searchType } = this.state;
        const { loading } = this.props;

        return (
            <div>
                <Row gutter={10}>
                    <Col className="gutter-row" span={5}>
                        <Select placeholder="Search By" style={{ width: 270 }} onChange={(value) => this.handleChange(value)} defaultValue="Customer Email" >
                            <Option value="Customer Email">Customer Email</Option>
                            <Option value="Transaction Reference">Transaction Reference</Option>
                        </Select>
                    </Col>
                    <Col className="gutter-row" span={5}>
                        <Input
                            placeholder={searchType}
                            value={this.state.searchParameter}
                            onChange={this.onSearchParmeterChange}
                            style={{ width: 300 }}
                        />
                    </Col>

                    <Col className="gutter-row" span={3}>
                        <DatePicker
                            disabledTime
                            disabledDate={this.disabledStartDate}
                            format="DD/MM/YYYY"
                            value={startValue}
                            placeholder="Start Date"
                            onChange={this.onStartChange}
                            onOpenChange={this.handleStartOpenChange}
                        />

                    </Col>
                    <Col className="gutter-row" span={3}>
                        <DatePicker
                            disabledDate={this.disabledEndDate}
                            format="DD/MM/YYYY"
                            value={endValue}
                            placeholder="End Date"
                            onChange={this.onEndChange}
                            open={endOpen}
                            onOpenChange={this.handleEndOpenChange}
                        />
                    </Col >
                    <Col>
                        <Col className="gutter-row" span={4}>
                            <Select placeholder="Transaction Status" style={{ width: 200 }} onChange={(value) => this.handleStatusChange(value)} value={this.state.transactionStatus ? this.state.transactionStatus : ''} >
                                <Option value="">All</Option>
                                <Option value="Pending">Pending Transaction</Option>
                                <Option value="DebitSuccessful">Successful Debit</Option>
                                <Option value="DebitFailed">Failed Debit</Option>
                                <Option value="AdviceSent">Sent SVA Call(s)</Option>
                                <Option value="AdviceFailed">Failed SVA Call(s)</Option>
                                <Option value="AdviceCompleted">Completed SVA Call(s)</Option>
                            </Select>

                        </Col>
                    </Col>

                    <Col className="gutter-row" span={4}>
                        <Button type="primary" icon="search" style={{ width: 200 }} onClick={this.onSearch} loading={loading}>
                            Search
                        </Button>
                        <br></br>
                        <br></br>
                        <span className="clear-search" onClick={this.clearSearch}>Clear Search Fields</span>

                    </Col>


                </Row>

            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        transactions: state.transaction,
        loading: state.loading,
        searchParam: state.searchParam
    }
}

export default connect(mapStateToProps, { getTransactions })(Search);
